import React from 'react'
import { Link } from 'react-router-dom'

export default function footer() {
  return (
    <div>
      <>
      {/* Footer Start */}
      <div
        className="container-fluid bg-dark text-body footer mt-5 pt-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container py-5">
          <div className="row g-5">

            {/* Address Section */}
            <div className="col-lg-3 col-md-6 text-light">
              <img
                src="/assests/img/baal-logo-footer.png"
                alt="BSCPCR Logo"
                className="img-fluid mb-3"
                style={{ maxWidth: "150px" }}
              />
              <p className="mb-2">
                <i className="fa fa-map-marker-alt me-2"></i>
                22B, Harding Road, Patna, Bihar-800001
              </p>
              <p className="mb-2">
                <i className="fa fa-fax me-2"></i>
                Contact No.: 0612-2217188/2215288
              </p>
               <p className="mb-2">
                <i className="fa fa-fax me-2"></i>
                Child Helpline No.: 1098
              </p>
               <p className="mb-2">
                <i className="fa fa-fax me-2"></i>
               Toll Free No.: 112
              </p>             
            </div>

            {/* Quick Links */}
            <div className="col-lg-3 col-md-6 text-light">
              <h5 className="text-light mb-4">Quick Links</h5>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <i className="fa fa-angle-right me-2"></i>
                  <Link to="/AboutChildRights" className="text-secondary text-decoration-none">
                    About Child Rights
                  </Link>
                </li>
                <li className="mb-2">
                  <i className="fa fa-angle-right me-2"></i>
                  <Link to="/about" className="text-secondary text-decoration-none">
                    About Commission
                  </Link>
                </li>
                <li className="mb-2">
                  <i className="fa fa-angle-right me-2"></i>
                  <Link to="/Chairman" className="text-secondary text-decoration-none">
                    Chairman
                  </Link>
                </li>
                <li className="mb-2">
                  <i className="fa fa-angle-right me-2"></i>
                  <Link to="/team" className="text-secondary text-decoration-none">
                    Members
                  </Link>
                </li>
                <li className="mb-2">
                  <i className="fa fa-angle-right me-2"></i>
                  <Link to="/OrganizationStructure" className="text-secondary text-decoration-none">
                    Organizational Structure
                  </Link>
                </li>
                <li>
                  <i className="fa fa-angle-right me-2"></i>
                  <Link to="/FunctionsAndPowers" className="text-secondary text-decoration-none">
                    Functions & Powers
                  </Link>
                </li>

                 <li>
                  <i className="fa fa-angle-right me-2"></i>
                  <Link to="/AnnualReport" className="text-secondary text-decoration-none">
                    Annual Report
                  </Link>
                </li>
                
              </ul>
            </div>

            {/* Useful Links */}
            <div className="col-lg-3 col-md-6 text-light">
              <h5 className="text-light mb-4">Useful Links</h5>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <i className="fa fa-angle-right me-2"></i>
                  <Link to="/" className="text-secondary text-decoration-none">
                    Home
                  </Link>
                </li>
                <li className="mb-2">
                  <i className="fa fa-angle-right me-2"></i>
                  <Link to="/acts" className="text-secondary text-decoration-none">
                    Acts
                  </Link>
                </li>
                <li className="mb-2">
                  <i className="fa fa-angle-right me-2"></i>
                  <Link to="/BareActs" className="text-secondary text-decoration-none">
                    Bare Acts (Children)
                  </Link>
                </li>
                <li className="mb-2">
                  <i className="fa fa-angle-right me-2"></i>
                  <Link to="/BSCPCRRules" className="text-secondary text-decoration-none">
                    BSCPCR Rules
                  </Link>
                </li>
                <li className="mb-2">
                  <i className="fa fa-angle-right me-2"></i>
                  <Link to="/Sop" className="text-secondary text-decoration-none">
                    SOP
                  </Link>
                </li>
                <li className="mb-2">
                  <i className="fa fa-angle-right me-2"></i>
                  <Link to="/RegisterComplaint" className="text-secondary text-decoration-none">
                    Register Complaint
                  </Link>
                </li>
                
              </ul>
            </div>

            {/* Media & Contact */}
          <div className="col-lg-3 col-md-6">
  <h5 className="text-light mb-4">Our Location</h5>

  <div className="bg-light rounded shadow-sm overflow-hidden">
    <iframe
      title="BSCPCR Location"
      src="https://www.google.com/maps?q=25.596744,85.115815&z=16&output=embed"
      width="100%"
      height="200"
      style={{ border: 0 }}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
</div>

          </div>
        </div>

        {/* Copyright */}
        <div className="container-fluid copyright py-3 bg-dark text-secondary">
          <div className="container">
            <div className="row">
              <div className="col-md-6 text-center text-md-start">
                © <Link to="/" className="text-secondary">BSCPCR</Link>, All Rights Reserved.
              </div>
              <div className="col-md-6 text-center text-md-end">
                Designed by <Link to="/" className="text-secondary">Your Organization</Link>
              </div>
            </div>
          </div>
        </div>
      </div>

     <button
  className="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top"
  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
>
  <i className="bi bi-arrow-up"></i>
</button>
    </>

    </div>
  )
}
